module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#envelope",
      toString: function () {
        return this.url;
      }
    }